// Geteilter Helper: baut die auswählbaren Visitor-Tag-Optionen für einen
// konkreten Standort. Wird von den Visitor-Modals (Create/Edit/Add) und dem
// Workflow-Auschecken-Filter genutzt, damit alle dieselbe Sicht haben.
//
// Regeln:
// - Nur Visitor-Tags (tag_type "visitor"; defensiv, der Endpoint liefert eh nur
//   solche).
// - Kundenweite Tags (location_id == null) gelten überall.
// - Standortgebundene Tags erscheinen nur beim passenden Standort.
// - Dedupe nach Label: existiert ein Label sowohl kundenweit als auch für den
//   Standort, gewinnt der standortspezifische Tag (spezifischer schlägt global).
//
// `valueKey` bestimmt das Option-`value`:
//   "tag_label" (Default) — Visitor-Modals arbeiten label-basiert.
//   "id"                   — Workflow-config speichert Tag-IDs.
export function buildVisitorTagOptions(tags, locationId, valueKey = "tag_label") {
  const eligible = (tags || [])
    .filter((t) => !t.tag_type || t.tag_type === "visitor")
    // Bewusst über String verglichen: die Standort-ID kommt je nach Aufrufer als
    // Zahl (Web) oder als String (Outlook-Add-in) an.
    .filter(
      (t) =>
        t.location_id == null || String(t.location_id) === String(locationId),
    );

  // Dedupe nach Label; standortspezifisch (location_id gesetzt) schlägt kundenweit.
  const byLabel = new Map();
  for (const t of eligible) {
    const existing = byLabel.get(t.tag_label);
    if (!existing || (existing.location_id == null && t.location_id != null)) {
      byLabel.set(t.tag_label, t);
    }
  }

  // `description` wird mitgegeben — Combobox/MultiCombobox zeigen sie als
  // Info-Tooltip neben der Option bzw. dem gewählten Chip.
  //
  // `defaultDoorPermissions` ebenso: die Masken belegen damit die Türberechti-
  // gungen vor. Weil die Dedupe-Regel oben den standortspezifischen Tag gewinnen
  // lässt, sind es garantiert die Berechtigungen DIESES Standorts — ein
  // gleichnamiger Tag eines anderen Standorts kann sich nicht einschleichen.
  return Array.from(byLabel.values()).map((t) => ({
    value: t[valueKey],
    label: t.tag_label,
    description: t.description || null,
    defaultDoorPermissions: t.default_door_permissions || [],
    maxDurationDays: t.max_duration_days ?? null,
  }));
}
